import { render } from "./PrintBadgeView.vue?vue&type=template&id=96fb8ebe&scoped=true"
import script from "./PrintBadgeView.vue?vue&type=script&lang=js"
export * from "./PrintBadgeView.vue?vue&type=script&lang=js"

import "./PrintBadgeView.vue?vue&type=style&index=0&id=96fb8ebe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96fb8ebe"]])

export default __exports__